(() => {
  const root = window.Shopify?.routes?.root || '/';
  const normalize = value => {
    let p = String(value || '').trim().replace(/[٠-٩]/g, c => String(c.charCodeAt(0) - 1632)).replace(/[۰-۹]/g, c => String(c.charCodeAt(0) - 1776)).replace(/[\s()\-]/g, '');
    if (p.startsWith('+')) p = p.slice(1);
    else if (p.startsWith('00')) p = p.slice(2);
    else if (/^01[0125]\d{8}$/.test(p)) p = '20' + p.slice(1);
    return /^[1-9]\d{7,14}$/.test(p) ? '+' + p : '';
  };
  const sync = fields => {
    const yes = fields.querySelector('[data-wa-choice]').value === 'yes';
    const input = fields.querySelector('[data-wa-phone]');
    input.required = yes;
    fields.querySelector('[data-wa-phone-wrap]').hidden = !yes;
    if (!yes) { input.value = ''; input.setCustomValidity(''); }
  };
  const valid = fields => {
    const choice = fields.querySelector('[data-wa-choice]');
    const input = fields.querySelector('[data-wa-phone]');
    if (!choice.reportValidity()) return false;
    if (choice.value !== 'yes') { input.value = ''; return true; }
    const normalized = normalize(input.value);
    input.setCustomValidity(normalized ? '' : fields.dataset.invalidPhone);
    if (!input.reportValidity()) return false;
    input.value = normalized;
    return true;
  };
  document.querySelectorAll('[data-wa-fields]').forEach(fields => {
    sync(fields);
    fields.querySelector('[data-wa-choice]').addEventListener('change', () => sync(fields));
    fields.querySelector('[data-wa-phone]').addEventListener('input', e => e.target.setCustomValidity(''));
    const form = fields.closest('form');
    form?.addEventListener('submit', e => {
      if (e.submitter?.name === 'update') return;
      if (!valid(fields)) e.preventDefault();
    });
  });
  const dialog = document.getElementById('FrematWhatsAppDialog');
  if (!dialog) return;
  const fields = dialog.querySelector('[data-wa-fields]');
  const next = dialog.querySelector('[data-wa-continue]');
  const close = dialog.querySelector('[data-wa-close]');
  const error = dialog.querySelector('[data-wa-error]');
  const recovery = dialog.querySelector('[data-wa-recovery]');
  let productForm, opener, busy = false, uncertain = false;
  const post = async (path, body) => {
    const response = await fetch(root + path, {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || fields.dataset.requestError);
    return data;
  };
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-fremat-buy-now]');
    if (!button || busy) return;
    e.preventDefault();
    productForm = button.closest('form');
    if (!productForm || productForm.querySelector('[data-add-to-cart]')?.disabled || !productForm.reportValidity()) return;
    if (!/^\d+$/.test(productForm.querySelector('[name="id"]')?.value || '')) return;
    opener = button;
    error.hidden = !uncertain;
    recovery.hidden = !uncertain;
    next.disabled = uncertain;
    dialog.showModal();
    fields.querySelector('[data-wa-choice]').focus();
  });
  close.addEventListener('click', () => { if (!busy) dialog.close(); });
  dialog.addEventListener('cancel', e => { if (busy) e.preventDefault(); });
  dialog.addEventListener('close', () => opener?.focus());
  next.addEventListener('click', async () => {
    if (busy || uncertain || !productForm || !valid(fields)) return;
    const formData = new FormData(productForm);
    const id = String(formData.get('id') || '');
    const quantity = Number(formData.get('quantity') || 1);
    if (!/^\d+$/.test(id) || !Number.isInteger(quantity) || quantity < 1 || !productForm.reportValidity()) return;
    const properties = Object.fromEntries([...formData].filter(([key,value]) => /^properties\[[^\]]+\]$/.test(key) && typeof value === 'string').map(([key,value]) => [key.slice(11,-1),value]));
    const sellingPlan = formData.get('selling_plan');
    const item = {id,quantity,properties,...(sellingPlan ? {selling_plan:sellingPlan} : {})};
    busy = true; next.disabled = true; close.disabled = true; error.hidden = true;
    const choice = fields.querySelector('[data-wa-choice]').value;
    const recipient = choice === 'yes' ? fields.querySelector('[data-wa-phone]').value : '';
    try {
      await post('cart/update.js', {attributes:{fremat_whatsapp_opt_in:choice,fremat_whatsapp_phone:recipient}});
      uncertain = true;
      await post('cart/add.js', {items:[item]});
      window.location.assign(root + 'checkout');
    } catch (failure) {
      error.textContent = fields.dataset.requestError;
      error.hidden = false;
      recovery.hidden = false;
      busy = false; next.disabled = uncertain; close.disabled = false;
    }
  });
})();
